/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-02 16:49:07
 * @modify date 2021-09-02 16:49:07
 * @desc 资料，市场活动，资源中心
 */
import { CertController } from './cert';
import { GoodCaseController } from './goodCase';
import { LiveController } from './live';
import { MaterialsController } from './materials';
import { NoticeController } from './notice';
import { ProductSourceController } from './productSource';
import SearchParamsController from './searchParams';

export class InformationController {
  /**
   * @dec 直播活动
   * @rm 因为这个 比较特殊且和 市场活动有关联 所以直接放 MaterialsController
   * @memberof MaterialsController
   */
  LiveController = new LiveController();
  /**
   * 市场活动 资讯
   * @memberof InformationController
   */
  MaterialsController = new MaterialsController();
  /**
   * 搜索参数
   * @memberof MaterialsController
   */
  SearchParamsController = new SearchParamsController();
  /* 招投标公告 */
  NoticeController = new NoticeController();
  /* 内容中心 */
  ProductSourceController = new ProductSourceController();
  /**
   * 证书
   */
  CertController = new CertController();
  /**
   * 优秀合作案例
   * @memberof GoodCaseController
   */
  GoodCaseController = new GoodCaseController();
}
